<script>
import TWEEN from 'tween.js'
import RND from '../utils/random'

export default {
	name: 'BadStory6',
	props: ['alpha'],
	data() {
		return {
			rolling: false,
			rollCount: 0,
			slotOffset: 0,
			screenSize: 0,
			slotPos: {
				1: 0,
				2: 0,
				3: 0
			},
			winRoll: 6,
		}
	},
	mounted() {
		this.resize()
		this.slotPos[1] = RND.range(0, 9) * this.slotOffset
		this.slotPos[2] = RND.range(0, 9) * this.slotOffset
		this.slotPos[3] = RND.range(0, 9) * this.slotOffset

		this.winRoll = RND.range(4, 8)

		window.addEventListener('resize', this.resize)
	},
	methods: {
		rollStyle(index) {
			let pos = this.slotPos[index] + this.screenSize / 2
			return {backgroundPosition: `0 ${pos}px`}
		},
		resize() {
			this.slotOffset = 100
			this.screenSize = window.innerWidth * 0.15 - 100
		},
		roll() {

			if (this.rolling) return
			this.rolling = true

			let target1 = RND.range(0, 9)
			let target2 = RND.range(0, 9)
			let target3 = RND.range(0, 9)

			this.rollCount++

			if (this.rollCount === this.winRoll) {
				target1 = target2 = target3
			}

			let _this = this
			let tw1 = new TWEEN.Tween({pos: 0})
				.to({pos: 5000 + this.slotOffset * target1}, 4000)
				.easing(TWEEN.Easing.Quadratic.Out)
				.onUpdate(function (e) {
					_this.slotPos[1] = this.pos
				})

			let tw2 = new TWEEN.Tween({pos: 0})
				.to({pos: 5000 + this.slotOffset * target2}, 5000)
				.easing(TWEEN.Easing.Quadratic.Out)
				.onUpdate(function (e) {
					_this.slotPos[2] = this.pos
				})

			let tw3 = new TWEEN.Tween({pos: 0})
				.to({pos: 5000 + this.slotOffset * target3}, 6000)
				.easing(TWEEN.Easing.Quadratic.Out)
				.onUpdate(function (e) {
					_this.slotPos[3] = this.pos
				})
				.onComplete(() => {
					this.rolling = false
				})

			tw1.start()
			tw2.start()
			tw3.start()

		}
	}
}
</script>



<template>
<div class="story big"  :style="{opacity: alpha}">
	<img class="image" src="../assets/bad/story6.jpg">
	<div class="mask"></div>
	<div class="slots">
		<div class="slot" @click="roll">
			<div class="screen">
				<div class="roll" :style="rollStyle(1)"></div>
				<div class="roll-mask"></div>
			</div>
		</div>
		<div class="slot" @click="roll">
			<div class="screen">
				<div class="roll" :style="rollStyle(2)"></div>
				<div class="roll-mask"></div>
			</div>
		</div>
		<div class="slot" @click="roll">
			<div class="screen">
				<div class="roll" :style="rollStyle(3)"></div>
				<div class="roll-mask"></div>
			</div>
		</div>
	</div>
</div>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.story {
	float: left;
	position: relative;
	overflow: hidden;
	cursor: pointer;
	background: #000;
}

.big {
	width: 50vw;
	height: 25vw;
}

.image {
	width: 101%;
	height: 101%;
	position: absolute;
	background-size: cover;
	background-position: center;
	transition: all 300ms ease;
	opacity: 0.3;
}

.mask {
	width: 100%;
	height: 102%;
	position: absolute;
	background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: #fff;
}

.slots {
	width: 50vw;
	//left: 2.5vw;
	height: 100%;
	position: absolute;
}

.slot {
	width: 16.6vw;
	height: 100%;
	background: rgba(0,0,0,0.4);
	position: relative;
	float: left;
}

.slot .screen {
	width: 16.6vw;
	height: 15vw;
	background: #232323;
	top: 50%;
	position: absolute;
	transform: translateY(-50%);
	overflow: hidden;
}

.slot .screen .roll {
	width: 100px;
	height: 100%;
	left: 50%;
	top: 0;
	margin-left: -50px;
	position: absolute;
	background-image: url(../assets/bad/slot.png);
	background-size: 100px;
	background-repeat: repeat-y;
}

.slot .roll-mask {
	width: 200%;
	height: 100%;
	position: absolute;
	box-shadow: inset 0 0 100px 10px rgba(0, 0, 0, 0.7);
	transform: translateX(-25%);
}



</style>



// WEBPACK FOOTER //
// BadStory6.vue?46d92dea